import classNames from 'classnames';

import { FormattedMessage } from '@features/intl';

import Lock from 'src/assets/icons/lock.svg';
import PayPalLogo from 'src/assets/images/new-plan-paywall/paypal.svg';
import AmexLogo from 'src/assets/images/payment/amex-logo.svg';
import MasterCardLogo from 'src/assets/images/payment/mastercard-logo.svg';
import UnionPayLogo from 'src/assets/images/payment/unionpay-logo.svg';
import VisaLogo from 'src/assets/images/payment/visa-logo.svg';

import styles from './index.module.css';

const LOGOS = (
  <div className={styles.logos}>
    <VisaLogo className={styles.svg} />
    <MasterCardLogo className={styles.svg} />
    <PayPalLogo className={styles.svg} />
    <AmexLogo className={styles.svg} />
    <UnionPayLogo className={styles.svg} />
  </div>
);

type TpGuaranteeBlockProps = {
  withFrame?: boolean;
};

export const GuaranteeBlock = (props: TpGuaranteeBlockProps) => {
  const { withFrame = true } = props;
  return (
    <div className={classNames(styles.info, withFrame && styles.withFrame)}>
      <h3 className={styles.title}>
        <FormattedMessage
          defaultMessage="Guaranteed Safe Checkout"
          id="Onboarding.Paywall.Main.SafeCheckout"
        />
      </h3>
      {LOGOS}
      <div className={styles.row}>
        <Lock />
        <p className={styles.description}>
          <FormattedMessage
            defaultMessage="All transactions are secure and encrypted"
            id="Onboarding.Paywall.Main.Encrypted"
          />
        </p>
      </div>
    </div>
  );
};
